{
  "title": "Statistics",
  "empty_state": "Your progress statistics will appear here.",
  "backend_pending": "Backend pending",
  "metrics_error_title": "Statistics unavailable",
  "metrics_error_message": "We couldn't load your statistics. Check your connection and try again.",
  "metric_warmups_title": "Warm ups",
  "metric_time_title": "Time",
  "metric_exercises_title": "Exercises",
  "metric_total_title": "Total",
  "metric_current_streak_title": "Current streak",
  "metric_best_streak_title": "Best streak",
  "metric_warmups_value_completed": "{{count}} completed",
  "metric_time_value_minutes_one": "{{count}} min",
  "metric_time_value_minutes_other": "{{count}} min",
  "metric_time_value_hours_one": "{{count}} hour",
  "metric_time_value_hours_other": "{{count}} hours",
  "metric_time_value_days_one": "{{count}} day",
  "metric_time_value_days_other": "{{count}} days",
  "metric_exercises_value_completed": "{{count}} completed",
  "timeframe_this_week": "This week",
  "timeframe_since_start": "Since start",
  "timeframe_activity_goal_reached": "Activity goal reached",
  "timeframe_past_30_days": "Past 30 days",
  "exercise_goal_label": "Exercise goal",
  "exercise_goal_value_per_week_one": "{{count}} exercise per week",
  "exercise_goal_value_per_week_other": "{{count}} exercises per week",
  "exercise_goal_modal_title": "How many times a week do you want to exercise?",
  "exercise_goal_update_failed": "Failed to update exercise goal.",
  "week_unit_one": "week",
  "week_unit_other": "weeks",
  "exercise_unit_one": "exercise",
  "exercise_unit_other": "exercises",
  "voice_assessment_section_title": "Latest voice assessment",
  "voice_assessment_microphone_accessibility": "Voice assessment",
  "voice_assessment_history_link": "History",
  "voice_assessment_empty_title": "No assessments",
  "voice_assessment_empty_subtitle": "You have a pending voice assessment to do.",
  "voice_assessment_error_title": "Voice assessment unavailable",
  "voice_assessment_error_message": "We couldn’t load your latest voice assessment. Try again, or continue with your other exercises.",
  "voice_assessment_placeholder_dash": "–",
  "voice_assessment_start_button": "Start assessment",
  "voice_assessment_analyzing_title": "Analyzing latest voice assessment",
  "voice_assessment_analysis_ready_title": "Analysis complete",
  "voice_assessment_analysis_ready_message": "Your latest voice assessment results are ready.",
  "voice_assessment_analysis_failed_title": "Analysis failed",
  "voice_assessment_analysis_failed_message": "We couldn't analyse your latest voice assessment. Please try again.",
  "voice_assessment_history_row_analyzing": "Analyzing",
  "voice_assessment_voice_feeling_label": "Voice feeling",
  "voice_assessment_mental_state_label": "Mental state",
  "voice_assessment_measurement_title": "Measurement {{n}}",
  "voice_assessment_question_title": "Question {{n}}",
  "voice_assessment_metric_voice_freedom": "Voice freedom",
  "voice_assessment_metric_ease_of_exercise": "Ease of exercise",
  "voice_assessment_metric_tension": "Tension",
  "voice_assessment_metric_tension_placement": "Tension placement",
  "voice_assessment_reflection_label": "Personal reflection",
  "voice_assessment_rating_out_of": "{{rating}}/{{max}}",
  "voice_assessment_history_screen_title": "Voice assessment history",
  "voice_assessment_details_screen_title": "Voice assessment details",
  "voice_assessment_voice_context_section_title": "Voice context",
  "voice_assessment_singing_score_label": "Singing score",
  "voice_assessment_comfortable_range_label": "Comfortable range",
  "voice_assessment_pitch_range_label": "Pitch range",
  "voice_assessment_recording_label": "Recording",
  "voice_assessment_recording_loading": "Loading recording…",
  "voice_assessment_recording_error_title": "Recording unavailable",
  "voice_assessment_recording_error_message": "We couldn't load this audio right now.",
  "voice_assessment_recording_retry_button": "Retry",
  "voice_assessment_latest_title": "Latest voice assessment",
  "voice_assessment_history_exercise_count_one": "{{count}} measurement",
  "voice_assessment_history_exercise_count_other": "{{count}} measurements",
  "voice_assessment_history_row_error_title": "Assessment unavailable",
  "voice_assessment_history_row_error_message": "We couldn't load this assessment. Check your connection and try again.",
  "voice_assessment_aborted_title": "Analysis aborted",
  "voice_assessment_not_analyzed_title": "Not analyzed",
  "voice_assessment_stats_pending_body": "Your measurement is saved. Detailed statistics will appear here when they are available.",
  "voice_assessment_retry_button": "Retry",
  "voice_assessment_history_entry_heading": "{{date}}",
  "voice_assessment_mental_state_tired": "Tired",
  "voice_assessment_mental_state_focused": "Focused",
  "voice_assessment_tension_placement_jaw_tongue": "Jaw/tongue",
  "voice_assessment_tension_placement_neck_shoulders": "Neck/shoulders",
  "voice_assessment_statistics_current_label": "Current",
  "voice_assessment_segment_weekly": "Weekly",
  "voice_assessment_segment_monthly": "Monthly",
  "voice_assessment_segment_six_months": "6 months",
  "voice_assessment_segment_all": "All",
  "voice_assessment_segment_yearly": "Yearly",
  "voice_assessment_range_section_title": "Range",
  "voice_assessment_range_current_heading": "Current",
  "voice_assessment_range_historic_heading": "Historic",
  "voice_assessment_chart_note_a4": "A4",
  "voice_assessment_chart_note_b4": "B4",
  "voice_assessment_chart_note_c5": "C5",
  "voice_assessment_chart_note_d5": "D5",
  "voice_assessment_chart_note_e5": "E5",
  "voice_assessment_chart_note_f5": "F5",
  "voice_assessment_chart_note_g5": "G5",
  "voice_assessment_chart_month_jan": "Jan",
  "voice_assessment_chart_month_feb": "Feb",
  "voice_assessment_chart_month_mar": "Mar",
  "voice_assessment_chart_month_apr": "Apr",
  "voice_assessment_chart_month_may": "May",
  "voice_assessment_chart_month_jun": "Jun",
  "voice_assessment_chart_month_jul": "Jul",
  "voice_assessment_chart_month_aug": "Aug",
  "voice_assessment_chart_month_sep": "Sep",
  "voice_assessment_chart_month_oct": "Oct",
  "voice_assessment_chart_month_nov": "Nov",
  "voice_assessment_chart_month_dec": "Dec",
  "voice_type_section_title": "Voice type",
  "voice_type_soprano": "Soprano",
  "voice_type_alto": "Alto",
  "voice_type_tenor": "Tenor",
  "voice_type_bass": "Bass",
  "voice_type_baritone": "Baritone",
  "voice_type_mezzoSoprano": "Mezzo-Soprano"
}
